
import { supabase } from "@/integrations/supabase/client";
import type { Prize } from "./types/winner";

export async function selectPrize(tipId: number): Promise<Prize | null> {
  try {
    console.log('Selecting prize for tip:', tipId);
    
    // Get active university
    const { data: universities, error: universityError } = await supabase
      .from('universities')
      .select('id')
      .eq('is_active', true)
      .single();

    if (universityError) {
      console.error('Error fetching active university:', universityError);
      throw universityError;
    }

    // Get available prizes with remaining allocations
    const { data: availablePrizes, error: prizesError } = await supabase
      .from('available_prize_allocations')
      .select('*')
      .eq('university_id', universities.id)
      .eq('is_available', true);

    if (prizesError) {
      console.error('Error fetching available prizes:', prizesError);
      throw prizesError;
    }

    if (!availablePrizes || availablePrizes.length === 0) {
      console.log('No available prizes found');
      return null;
    }

    // Calculate total remaining allocations for weighted selection
    const totalRemaining = availablePrizes.reduce((sum, prize) => 
      sum + (prize.remaining_allocations || 0), 0
    );

    console.log('Total remaining allocations:', totalRemaining);

    if (totalRemaining <= 0) {
      console.log('No remaining allocations available');
      return null;
    }

    // Select random prize based on remaining allocation weights
    const randomNum = Math.random() * totalRemaining;
    let cumulativeWeight = 0;

    for (const prize of availablePrizes) {
      const remaining = prize.remaining_allocations || 0;
      cumulativeWeight += remaining;
      
      if (randomNum <= cumulativeWeight) {
        console.log('Selected prize allocation:', prize);
        return {
          id: prize.prize_id,
          name: prize.prize_name,
          description: prize.prize_description,
          created_at: prize.prize_created_at,
          filename: prize.prize_filename
        };
      }
    }

    console.log('No prize was selected');
    return null;
  } catch (error) {
    console.error('Error in selectPrize:', error);
    throw error;
  }
}
